import React, { useEffect, useState } from "react";
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../css/style.css";
import img from "../assets/HKCL_Logo.png";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isRegisterPage = ["/login", "/register"].includes(location.pathname);
  useEffect(() => {
    checkLogin();
  }, [navigate])
  const handleScroll = (event, targetId) => {
    event.preventDefault();
    const headerHeight = document.querySelector("nav").offsetHeight;
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: targetPosition - headerHeight, 
        behavior: "smooth",
      });
    }
  };
  const checkLogin = () => {
    const userDetailsString = sessionStorage.getItem('userDetails');
    if (userDetailsString) {
      const userDetails = JSON.parse(userDetailsString);
      const expireDate = new Date(userDetails.expireDate);
      if (expireDate < new Date()) {
        // navigate("/")
      } else {
        navigate("/dashboard/home")
      }
    } else {
      // navigate("/")
    }

  }

  return (
    <Navbar light expand="md" fixed="top" className="shadow-sm">
       <NavbarBrand tag={Link} to="/" className="brand">
        <img src={img} alt="Logo" className="logo-out" />
        <div className="d-flex flex-column">
          <span className="brand-text">Haryana Knowledge Corporation Limited</span>
          <span className="brand-sub">Promoted by Government of Haryana</span>
          <span className="brand-sub">ISO 9001:2015 Certified Organization</span>
        </div>
      </NavbarBrand>
      <NavbarToggler onClick={() => setIsOpen(!isOpen)} />
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ms-auto" navbar>
          {!isRegisterPage ? (
            <>
              <NavItem>
                <NavLink href="#home" className="nav-link" onClick={(e) => handleScroll(e, "home")}>Home</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#about-us" className="nav-link" onClick={(e) => handleScroll(e, "about-us")}>About Us</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#seminardetails" className="nav-link" onClick={(e) => handleScroll(e, "seminardetails")}> About Mentza
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#pricing" className="nav-link" onClick={(e) => handleScroll(e, "pricing")}>Pricing</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#faqsection" className="nav-link" onClick={(e) => handleScroll(e, "faqsection")}>FAQ</NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} to={"/login"} className="nav-link">Partner Login</NavLink>
              </NavItem>
              <NavItem>
                <Button
                  color="success"
                  className="enroll-btn me-3 blink-btn"
                  onClick={() => navigate("/register")}
                >
                  Enroll Now
                </Button>
              </NavItem>
            </>
          ) : <NavItem>
            <NavLink tag={Link} to={"/"} className="nav-link">Home</NavLink>
          </NavItem>}

        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default Header;
